
import { Component, Mixins } from "vue-property-decorator";
import { IScaleEditable } from "../../../../domain/system/presentation";

@Component
export default class ScaleEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IScaleEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IScaleEditable) => T, defaultValue: T) => T;

  get currentScale(): number {
    return this.readPropertyOrDefault(s => s.getCurrentScale(), 1.0);
  }

  set currentScale(value: number) {
    this.writePropertyWhenValid(s => s.setCurrentScale(value));
  }
}
